import { render } from "./courier_details.vue?vue&type=template&id=18d010a0"
import script from "./courier_details.vue?vue&type=script&lang=js"
export * from "./courier_details.vue?vue&type=script&lang=js"

import "./courier_details.vue?vue&type=style&index=0&id=18d010a0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__